var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbstractPlace',_vm._b({attrs:{"icon":"mdi-home","iconColor":"warning","btnColor":"#FF98004D","type":"homeplace"},nativeOn:{"click":function($event){return _vm.emitSelectHomeplace($event)}}},'AbstractPlace',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }